export function hideApplyFormLabels() {
  const applyForm = document.querySelector('.c-form--apply')
  const fields = [...applyForm.querySelectorAll('.c-form__row')]
  fields.forEach((field) => {
    const fieldNumber = field.id.slice(5)
    const input = field.querySelector(`#input${fieldNumber}`)
    input.addEventListener('focus', () => {
      const label = field.querySelector('.gfield_label')
      label.setAttribute('style', 'display: none;')
    })
    input.addEventListener('blur', () => {
      const label = field.querySelector('.gfield_label')
      if (input.value == '') {
        label.setAttribute('style', 'display: block;')
      }
    })
  })
}

export function hideFundingFormLabels() {
  const applyForm = document.querySelector('.c-funding-modal')
  if (applyForm) {
    const fields = [...applyForm.querySelectorAll('.c-form__row')]
    fields.forEach((field) => {
      const fieldNumber = field.id.slice(5)
      const input = field.querySelector(`#input${fieldNumber}`)
      input.addEventListener('focus', () => {
        const label = field.querySelector('.gfield_label')
        label.setAttribute('style', 'display: none;')
      })
      input.addEventListener('blur', () => {
        const label = field.querySelector('.gfield_label')
        if (input.value == '') {
          label.setAttribute('style', 'display: block;')
        }
      })
    })
  }
}
